import { useState, useEffect, useCallback } from "react";

const useTripData = (tripId) => {
  const [trip, setTrip] = useState(null);
  const [subTrips, setSubTrips] = useState([]);
  const [subTripItems, setSubTripItems] = useState([]);

  const fetchTripDetails = useCallback(async () => {
    const token = localStorage.getItem("token");
    const res = await fetch(`${process.env.REACT_APP_API_URL}/trips/trips/${tripId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.ok) {
      const data = await res.json();
      setTrip(data);
    } else {
      console.error("Failed to fetch trip details:", res.status);
    }
  }, [tripId]);

  const fetchSubTrips = useCallback(async () => {
    const token = localStorage.getItem("token");
    const res = await fetch(`${process.env.REACT_APP_API_URL}/subtrips/parent_trip/${tripId}/sub_trips`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.ok) {
      const data = await res.json();
      setSubTrips(data);
    } else {
      console.error("Failed to fetch sub trips:", res.status);
    }
  }, [tripId]);

  const fetchAllSubTripItems = useCallback(async () => {
    const token = localStorage.getItem("token");

    try {
      const allItems = [];

      for (const subTrip of subTrips) {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/${subTrip.id}/items`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.ok) {
          const items = await res.json();
          allItems.push(...items.map(item => ({ ...item, sub_trip_id: subTrip.id })));
        }
      }

      setSubTripItems(allItems);
    } catch (err) {
      console.error("Failed to fetch sub trip items:", err);
    }
  }, [subTrips]);

  useEffect(() => {
    fetchTripDetails();
    fetchSubTrips();
  }, [fetchTripDetails, fetchSubTrips]);

  useEffect(() => {
    if (subTrips.length > 0) {
      fetchAllSubTripItems();
    }
  }, [subTrips, fetchAllSubTripItems]);

  const refreshSubTripData = useCallback(async () => {
    await fetchSubTrips(); // 更新 subTrips，會自動觸發 useEffect 去 fetchAllSubTripItems
  }, [fetchSubTrips]);

  return {
    trip,
    setTrip,
    subTrips,
    fetchSubTrips,
    subTripItems,
    fetchAllSubTripItems,
    fetchTripDetails,
	refreshSubTripData,
  };
};

export default useTripData;
